/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import GatewayMap from 'loracoms/GatewayMap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import styles from './styles.scss';

const defaultProps = {
  search: '',
};

const propTypes = {
  search: React.PropTypes.string,
  intl: React.PropTypes.object.isRequired,
};

class Map extends React.Component {

  static getQ(s) {
    if (s !== '') {
      return `or,id:*${s}*,name:*${s}*,platform:*${s}*,mac:*${s}*,city:*${s}*,area:*${s}*,version:*${s}*`;
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = { gateways: [] };
    this.intlMsg = new IntlMsg(props.intl, 'gateway.map');
  }

  componentWillMount() {
    callAPI({
      endpoint: '/lora/gateways',
      query: { limit: 100 },
    }).then((data) => {
      this.setState({ gateways: data.list });
    }).catch(() => {});
  }

  componentWillReceiveProps(nextProps) {
    const { search } = nextProps;
    if (search !== this.props.search) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        callAPI({
          endpoint: '/lora/gateways',
          query: { limit: 100, q: Map.getQ(search) },
        }).then((data) => {
          this.setState({ gateways: data.list });
        }).catch(() => {});
      }, 500);
    }
  }

  render() {
    const { gateways } = this.state;

    if (_.isEmpty(gateways)) {
      return (
        <div className={styles.noGateway}>
          <h3>
            {this.intlMsg.msg('nogateway')}
          </h3>
        </div>
      );
    }
    return (
      <div className={styles.map}>
        <GatewayMap gateways={gateways} />
      </div>
    );
  }
}

Map.defaultProps = defaultProps;
Map.propTypes = propTypes;

export default connect(
  () => ({}),
  {
    pushState: routerActions.push,
  },
)(injectIntl(Map));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/Map/index.jsx